import { ApiRoutes } from '@gr/core/api-routes';
import type { PublicationDto } from '@gr/core/distribution/publishing/dto';
import type { CalendarQuery, QueueItemDto, SaveSchemeRequestDto, SchemeDto } from '@gr/core/distribution/scheduling/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient } from '../../../shared/http/http-client';

export class SchedulingApi {
  constructor(private readonly http: HttpClient) {}

  schemes(blogId: string): Promise<OperationResult<SchemeDto[]>> {
    return this.http.get(ApiRoutes.scheduling.schemes(blogId));
  }
  createScheme(blogId: string, input: SaveSchemeRequestDto): Promise<OperationResult<SchemeDto>> {
    return this.http.post(ApiRoutes.scheduling.schemes(blogId), input);
  }
  updateScheme(blogId: string, schemeId: string, input: SaveSchemeRequestDto): Promise<OperationResult<SchemeDto>> {
    return this.http.put(ApiRoutes.scheduling.scheme(blogId, schemeId), input);
  }
  deleteScheme(blogId: string, schemeId: string): Promise<OperationResult<null>> {
    return this.http.delete(ApiRoutes.scheduling.scheme(blogId, schemeId));
  }
  queue(blogId: string): Promise<OperationResult<QueueItemDto[]>> {
    return this.http.get(ApiRoutes.scheduling.queue(blogId));
  }
  enqueue(blogId: string, postId: string, schemeId: string): Promise<OperationResult<QueueItemDto[]>> {
    return this.http.post(ApiRoutes.scheduling.queue(blogId), { postId, schemeId });
  }
  reorder(blogId: string, itemIds: string[]): Promise<OperationResult<QueueItemDto[]>> {
    return this.http.put(ApiRoutes.scheduling.queueOrder(blogId), { itemIds });
  }
  dequeue(blogId: string, itemId: string): Promise<OperationResult<QueueItemDto[]>> {
    return this.http.delete(ApiRoutes.scheduling.queueItem(blogId, itemId));
  }
  scheduleExact(blogId: string, postId: string, schemeId: string, at: string): Promise<OperationResult<PublicationDto[]>> {
    return this.http.post(ApiRoutes.posts.schedule(blogId, postId), { schemeId, at });
  }
  reschedule(blogId: string, publicationId: string, plannedAt: string): Promise<OperationResult<PublicationDto[]>> {
    return this.http.patch(ApiRoutes.publishing.byId(blogId, publicationId), { plannedAt });
  }
  unschedule(blogId: string, publicationId: string): Promise<OperationResult<PublicationDto[]>> {
    return this.http.delete(ApiRoutes.publishing.byId(blogId, publicationId));
  }
  calendar(blogId: string, query: CalendarQuery): Promise<OperationResult<PublicationDto[]>> {
    return this.http.get(ApiRoutes.scheduling.calendar(blogId), { ...query });
  }
}
